const invertedMessages = {
  'ID proofing': 'external.idpSetUp.isProofing',
};

export default invertedMessages;
